import Alert from "@mui/material/Alert";
import { formatDisplayDate } from "./helpers";
import { useTranslation } from "react-i18next";
import type { Abonement } from '@/pages/abonements/types'

type AbonementDynamicHintAlertProps = {
  abonementsLoading: boolean
  selectedAbonement: Abonement | null
  allAbonements?: Abonement[]
  selectedAbonementStartTime: string
  selectedAbonementEndTime: string
  isSelectedAbonementRoundTheClock: boolean
  startDate: string | Date | null
  endDate: string | Date | null
}

const AbonementDynamicHintAlert = ({
  abonementsLoading,
  selectedAbonement,
  allAbonements = [],
  selectedAbonementStartTime,
  selectedAbonementEndTime,
  isSelectedAbonementRoundTheClock,
  startDate,
  endDate
}: AbonementDynamicHintAlertProps) => {
  const { t } = useTranslation();
  const selectedAbonementResumeText = () => {
    if (!selectedAbonement) return ''
    const periodText = `${t('start_date')}: ${formatDisplayDate(
      startDate || selectedAbonement.start_at
    )} • ${t('end_date')}: ${formatDisplayDate(
      endDate || selectedAbonement.expire_at
    )}`
    
    const timeText = isSelectedAbonementRoundTheClock
      ? '24/7'
      : `${t('begin')}: ${
          selectedAbonementStartTime || t('not_selected')
        } • ${t('end')}: ${selectedAbonementEndTime || t('not_selected')}`
    
    const weekendsText = `${t('including_weekends')}: ${
      selectedAbonement.include_weekends ? t('yes') : t('no')
    }`

    return `${selectedAbonement.name || `#${selectedAbonement.id}`} (${
      selectedAbonement.payment_code || t('code')
    }) • ${Number(selectedAbonement.amount || 0).toLocaleString(
      'ru-RU'
    )} ₸\n${periodText}\n${timeText}\n${weekendsText}`
  }

  return (
    <Alert severity="info" sx={{ mb: 3, whiteSpace: 'pre-line' }}>
      {
        abonementsLoading ? `${t('choose_abonement')}...`
        : (!selectedAbonement && !allAbonements.length)
        ? `${t('no_abonements')}. ${t('abonements')} -> ${t('addAbonement')}.`
        : !selectedAbonement ? `${t('abonement')}: ${t('choose_abonement')}.`
        : selectedAbonementResumeText()
      }
    </Alert>
  )
}

export default AbonementDynamicHintAlert;
